import Vuex from "vuex";
import Vue from "vue";
import { getToken, setToken, removeToken,setExpires,removeExpires } from "@/request/token";
import { login, getUserInfo, logout, register } from "@/api/login";
import { getUSrPermissionCharacterAPI,getMenuAllAPI } from "@/api/menu";
Vue.use(Vuex)

//递归获取所有需要鉴权的path
function getWebPaths(menuList) {
  let webPaths = [];

  function traverse(node) {
      if (node.webPath) {
          webPaths.push(node.webPath);
      }
      if (node.submenu && Array.isArray(node.submenu)) {
          node.submenu.forEach(subNode => traverse(subNode));
      }
  }

  menuList.forEach(node => traverse(node));
  return webPaths;
}

export default new Vuex.Store({
  state: {
    id: "",
    typeCode: "", //1-雇主 2-人才 3-财务 4-超级管理员
    account: "",
    nickname: "",
    avatar: "",
    email: "",
    dialCode: "",
    phone: "",
    token: "",
    msgCount: 0, //未读的消息数量
    permissions: [], //权限列表
    webPaths: [], // 所有页面的路径
    menuList: [] // 树形菜单列表
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_ACCOUNT: (state, account) => {
      state.account = account;
    },
    SET_NICKNAME: (state, nickname) => {
      state.nickname = nickname;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_TYPE_CODE: (state, typeCode) => {
      state.typeCode = typeCode;
    },
    SET_EMAIL: (state, email) => {
      state.email = email;
    },
    SET_DIAL_CODE: (state, dialCode) => {
      state.dialCode = dialCode;
    },
    SET_PHONE: (state, phone) => {
      state.phone = phone;
    },
    SET_ID: (state, id) => {
      state.id = id;
    },
    SET_MSG_COUNT: (state, data) => {
      state.msgCount = data;
    },
    SET_PERMISSION_LIST: (state, data) => {
      state.permissions = data;
      // 触发权限更新事件
      Vue.prototype.$eventBus.$emit('permissions-updated');
    },
    SET_MENU_LIST: (state, data) => {
      state.menuList = data;
    },
    SET_WEB_PATHS: (state, data) => {
      state.webPaths = data;
    }
  },
  actions: {
    // 登录
    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        //console.info('user', user);
        login(
          user.account,
          user.password,
          user.email,
          user.phone,
          user.verificationCode,
          user.loginType
        )
          .then(data => {
            commit("SET_TOKEN", data.data["Oauth-Token"]);
            setToken(data.data["Oauth-Token"]);
            setExpires(data.data.expire)
            resolve();
          })
          .catch(error => {
            console.info("error", error);
            reject(error);
          });
      });
    },
    // 获取用户信息
    getUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        if (userInfo) {
          commit("SET_ACCOUNT", userInfo.data.account);
          commit("SET_NICKNAME", userInfo.data.nickname);
          commit("SET_AVATAR", userInfo.data.avatar);
          commit("SET_TYPE_CODE", userInfo.data.typeCode);
          commit("SET_EMAIL", userInfo.data.email);
          commit("SET_DIAL_CODE", userInfo.data.dialCode);
          commit("SET_PHONE", userInfo.data.phone);
          commit("SET_ID", userInfo.data.id);
          resolve(userInfo);
        } else {
          getUserInfo()
            .then(data => {
              if (data.data) {
                commit("SET_ACCOUNT", data.data.account);
                commit("SET_NICKNAME", data.data.nickname);
                commit("SET_AVATAR", data.data.avatar);
                commit("SET_TYPE_CODE", data.data.typeCode);
                commit("SET_EMAIL", data.data.email);
                commit("SET_DIAL_CODE", data.data.dialCode);
                commit("SET_PHONE", data.data.phone);
                commit("SET_ID", data.data.id);
                let userInfo = JSON.stringify(data);
                sessionStorage.setItem("userInfo", userInfo);
              } else {
                commit("SET_ACCOUNT", "");
                commit("SET_NICKNAME", "");
                commit("SET_AVATAR", "");
                commit("SET_TYPE_CODE", "");
                commit("SET_EMAIL", "");
                commit("SET_DIAL_CODE", "");
                commit("SET_PHONE", "");
                commit("SET_ID", "");
                removeToken();
              }
              resolve(data);
            })
            .catch(error => {
              reject(error);
            });
        }
      });
    },
    // 获取权限列表
    getPermissionList({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUSrPermissionCharacterAPI(state.id).then(res => {
          console.log('获取权限列表 permiList', res.data)
          commit("SET_PERMISSION_LIST", res.data || []);
          resolve(res.data)
        }).catch(error => {
          reject(error)
        })
      })
      
    },
    // 退出
    logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(data => {
            commit("SET_TOKEN", "");
            commit("SET_ACCOUNT", "");
            commit("SET_NICKNAME", "");
            commit("SET_AVATAR", "");
            commit("SET_TYPE_CODE", "");
            commit("SET_EMAIL", "");
            commit("SET_DIAL_CODE", "");
            commit("SET_PHONE", "");
            commit("SET_ID", "");
            commit('SET_PERMISSION_LIST',[])
            removeToken();
            removeExpires()
            resolve();
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 前端 登出
    fedLogOut({ commit }) {
      return new Promise(resolve => {
        commit("SET_TOKEN", "");
        commit("SET_ACCOUNT", "");
        commit("SET_NICKNAME", "");
        commit("SET_AVATAR", "");
        commit("SET_TYPE_CODE", "");
        commit("SET_EMAIL", "");
        commit("SET_DIAL_CODE", "");
        commit("SET_PHONE", "");
        commit("SET_ID", "");
        removeToken();
        resolve();
      }).catch(error => {
        reject(error);
      });
    },
    // 注册
    register({ commit }, user) {
      return new Promise((resolve, reject) => {
        register(
          user.typeCode,
          user.account,
          user.nickname,
          user.password,
          user.email,
          user.verificationCode
        )
          .then(data => {
            commit("SET_TOKEN", data.data["Oauth-Token"]);
            setToken(data.data["Oauth-Token"]);
            resolve();
          })
          .catch(error => {
            // reject(error)
          });
      });
    },
    // 获取菜单列表树形and url数组
    getMenuList({ commit, state }) {
      return new Promise((resolve, reject) => {
        getMenuAllAPI(state.id)
         .then(res => {
            const arr = res.data || []
            console.log('获取菜单/路由列表 permiList', getWebPaths(res.data))
            commit("SET_MENU_LIST", arr);
            commit("SET_WEB_PATHS", getWebPaths(arr));
            resolve(res.data)
          })
         .catch(error => {
            reject(error)
          })
      })  
    }

  }
});



// WEBPACK FOOTER //
// ./src/store/index.js